/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Nutritional View .
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './nutritionalView';

export const mapStateToPropsNutritionalView = mapStateToProps;
export const mapDispatchToPropsNutritionalView = mapDispatchToProps;

export default connect(
  mapStateToPropsNutritionalView,
  mapDispatchToPropsNutritionalView
)(View);
